(function () {
  function fitFabricAccordion() {
    var summaries = document.querySelectorAll('.product-details summary, .product-information summary');
    for (var i = 0; i < summaries.length; i++) {
      if (/fit\s*&\s*fabric/i.test(summaries[i].textContent || '')) {
        return summaries[i].closest('.accordion');
      }
    }
    return null;
  }

  function placeBundle() {
    var widget = document.querySelector('.gfbPageWrapper');
    var accordion = fitFabricAccordion();
    if (!widget || !accordion) return false;
    if (accordion.nextElementSibling === widget) return true;
    accordion.insertAdjacentElement('afterend', widget);
    return true;
  }

  function watch() {
    placeBundle();
    var observer = new MutationObserver(function () {
      var widget = document.querySelector('.gfbPageWrapper');
      var accordion = fitFabricAccordion();
      if (!widget || !accordion) return;
      if (accordion.nextElementSibling === widget) return;
      placeBundle();
    });
    var root = document.querySelector('.product-information') || document.body;
    observer.observe(root, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
